import type { FormValues } from "@/pages/home-page/model/form.schema";
import type { GetBranchResponse, GetEmployeeScheduleResponse, GetScheduleResponse } from "../types/types";

export const getBranch = async ({ branchId }: { branchId: number | undefined }): Promise<GetBranchResponse> => {
  const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/organization/branch/${branchId}`);
  if (!response.ok) {
    throw new Error(`Status ${response.status}`);
  }
  return response.json();
};
export const getEmployeeSchedule = async ({
  branchId,
  date,
  duration,
}: {
  branchId: number;
  date: string;
  duration: number;
}): Promise<GetEmployeeScheduleResponse> => {
  const response = await fetch(
    `${import.meta.env.VITE_APP_API_URL}/employee/schedule?branch_id=${branchId}&date=${date}&duration=${duration}`,
  );

  if (!response.ok) {
    throw new Error(`Status ${response.status}`);
  }
  return response.json();
};

export const getSchedule = async ({
  branchId,
  date,
  duration,
  employee_id,
}: {
  branchId: number;
  date: string;
  duration: number;
  employee_id: number;
}): Promise<GetScheduleResponse> => {
  const response = await fetch(
    `${
      import.meta.env.VITE_APP_API_URL
    }/order/schedule/?branch_id=${branchId}&employee_id=${employee_id}&date=${date}&duration=${duration}`,
    {},
  );
  if (!response.ok) {
    throw new Error(`Status ${response.status}`);
  }
  return response.json();
};

export type CreateOrderRequest = Omit<FormValues, "date" | "dur"> & {
  date: string;
};
export const createOrder = async (values: CreateOrderRequest): Promise<void> => {
  const { duration, ...restValues } = values;
  const response = await fetch(`${import.meta.env.VITE_APP_API_URL}/order`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      ...restValues,
      customer: {
        ...restValues.customer,
      },
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw data;
  }

  return data;
};
